module.exports = __webpack_public_path__ + "img/googleplay-badge-uk.0e05cecc.webp";